<script>
import { Line, mixins } from "vue-chartjs";

const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ["baseHexColor"],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        datasetStrokeWidth: 3,
        pointDotStrokeWidth: 4,
        tooltipFillColor: "rgba(0,0,0,0.8)",
        tooltipFontStyle: "bold",
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 100,
                stepSize: 20,
                callback: function(value, index, values) {
                  return value + "%";
                }
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    generateGradientBackground() {
      const ctx = this.$refs.canvas.getContext("2d");

      /*** Gradient ***/
      let gradient = ctx.createLinearGradient(0, 0, 0, 400);
      gradient.addColorStop(0, `${this.baseHexColor}54`);
      gradient.addColorStop(1, `${this.baseHexColor}10`);

      return gradient;
    },

    setChartFill(color) {
      this.$set(this.chartData.datasets[0], "backgroundColor", color);
    }
  },
  mounted() {
    this.setChartFill(this.generateGradientBackground());
    this.$nextTick(() => {
      this.renderChart(this.chartData, this.options);
    });
  }
};
</script>

<style lang="scss" scoped></style>
